import { Contact } from "@model/contacts/Contact";
import React from "react";
import { MechanicCardItem } from "@ui/common/MechanicCard";
import { TextInput } from "@ui/common/form/TextInput";

export function MechanicSelector({ mechanics, selected, OnSelected }: { mechanics: Contact[], selected: number | null, OnSelected: (mechanicId: number | null) => void }): JSX.Element {
    const [filteredMechanics, setFilteredMechanics] = React.useState<Contact[]>(mechanics);
    const [selectedMechanic, setSelectedMechanic] = React.useState<number | null>(selected);

    function filterMechanics(searchValue: string) {
        const filtered = mechanics.filter(mechanic =>
            mechanic?.firstName?.toLowerCase().includes(searchValue.toLowerCase()) ||
            mechanic?.lastName?.toLowerCase().includes(searchValue.toLowerCase()) ||
            mechanic?.displayName?.toLowerCase().includes(searchValue.toLowerCase()) ||
            mechanic?.email?.toLowerCase().includes(searchValue.toLowerCase()) ||
            mechanic?.title?.toLowerCase().includes(searchValue.toLowerCase())
        );
        setFilteredMechanics(filtered);
    }

    function OnSearchBoxChange(value: string) {
        // Logic to handle search box changes
        filterMechanics(value);
    }

    function OnMechanicSelected(mechanicId: number) {
        OnSelected(mechanicId);
        setSelectedMechanic(mechanicId);
        // Logic to handle mechanic selection
    }
    
    return (
        <div className="mechanic-selector">
            <TextInput className="search-box"  placeholder="Search technicians..." onChange={OnSearchBoxChange}></TextInput>
            <div className="mechanic-list" >
                {filteredMechanics.map(mechanic => (
                    <div key={mechanic.id} onClick={() => OnMechanicSelected(mechanic.id)} className={`mechanic-item ${selectedMechanic === mechanic.id ? 'selected' : ''}`}>
                        <MechanicCardItem mechanic={mechanic} onEdit={undefined} />
                    </div>
                ))}
            </div>
        </div>
    )
}
